module.exports = __webpack_public_path__ + "static/media/animal11.27add6c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animals/animal11.png
// module id = 763
// module chunks = 0